import { useEffect } from "react";

export const useTitle = (title: string, prefix?: string) => {
  useEffect(() => {
    document.title = `${prefix ?? `${window.__config__.name} `} ${title}`;
  }, [prefix, title]);
};
